import { baseApiInstance } from '@common/libs/meaAxios';
import { insertPathVariables } from '@common/libs/meaLodash';

import { getBaseUrl, getBaseTEMUrl } from './baseService';

const filterEmptyStrings = (filterObject) => {
  if (!filterObject) return;
  let checkedObj = { ...filterObject };
  // eslint-disable-next-line array-callback-return
  Object.keys(checkedObj).map((column) => {
    if (
      checkedObj[column] === undefined ||
      checkedObj[column] === null ||
      checkedObj[column] === ''
    )
      delete checkedObj[column];
  });
  return checkedObj;
};

const getDefaultOptions = ({
  method = 'get',
  params = undefined,
  data = undefined,
  baseURL = getBaseUrl(),
  url = undefined,
  responseType = undefined
}) => {
  return {
    baseURL,
    method,
    responseType,
    params,
    data,
    url,
    paramsSerializer: function paramsSerializer(params) {
      return Object.entries(Object.assign({}, params))
        .map(([key, value]) => {
          if (key === 'filters') {
            return `${key}=${encodeURIComponent(JSON.stringify(value))}`;
          }
          return `${key}=${value}`;
        })
        .join('&');
    }
  };
};

export const getByPathAndParams = ({
  path = '/',
  params,
  pathVariables,
  headers,
  temApi = false,
  responseType = ''
} = {}) => {
  return baseApiInstance(
    getDefaultOptions({
      baseURL: temApi ? getBaseTEMUrl() : getBaseUrl(),
      params: filterEmptyStrings(params),
      url: insertPathVariables(path, pathVariables),
      responseType,
      headers
    })
  );
};

export const getByLink = ({ link = '' } = {}) => {
  return baseApiInstance({ baseURL: link, method: 'post' });
};

// data - is value that will be sent as payload
export const putByPathAndData = ({ path = '/', data, pathVariables } = {}) => {
  return baseApiInstance(
    getDefaultOptions({
      url: insertPathVariables(path, pathVariables),
      data,
      method: 'put'
    })
  );
};

export const postByPathAndData = ({
  path = '/',
  data,
  pathVariables,
  params,
  headers,
  temApi = false,
  ...rest
} = {}) => {
  return baseApiInstance(
    getDefaultOptions({
      url: insertPathVariables(path, pathVariables),
      params: filterEmptyStrings(params),
      data,
      method: 'post',
      headers,
      baseURL: temApi ? getBaseTEMUrl() : getBaseUrl(),
      ...rest
    })
  );
};

export const patchByPathAndData = ({
  path = '/',
  data,
  pathVariables,
  params,
  headers,
  temApi = false,
  ...rest
} = {}) => {
  return baseApiInstance(
    getDefaultOptions({
      url: insertPathVariables(path, pathVariables),
      params: filterEmptyStrings(params),
      data,
      method: 'patch',
      headers,
      baseURL: temApi ? getBaseTEMUrl() : getBaseUrl(),
      ...rest
    })
  );
};

export const deleteByPath = ({ path = '/', pathVariables } = {}) => {
  return baseApiInstance(
    getDefaultOptions({
      url: insertPathVariables(path, pathVariables),
      method: 'delete'
    })
  );
};

// configList - is array of path strings
export const getAllByPathList = async (configList = [], language) => {
  const response = [];
  configList.map((path) => {
    response.push(getByPathAndParams({ path, params: { language_id: language } }));
  });
  return await Promise.all(response);
};
